export default __webpack_public_path__ + "static/mountains-498e8936534497ebbc75e0a9a855ff7c.jpg";